import * as React from 'react';

const Us16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#CB001C",
    d: "M2.991 13a2 2 0 0 1-1.568-.77h13.154a2 2 0 0 1-1.568.77zM1 10.69V11q0 .237.053.46h13.894Q15 11.238 15 11v-.31zm0-1.54h14v.77H1zm0-1.53h14v.77H1zm0-1.54h14v.77H1zm.053-1.54A2 2 0 0 0 1 5v.31h14V5q0-.237-.053-.46zM13 3H3c-.64 0-1.211.301-1.577.77h13.154A2 2 0 0 0 13 3"
  }
), /* @__PURE__ */ React.createElement("path", { fill: "#2A3560", d: "M1 5a2 2 0 0 1 2-2h4.39v5.39H1z" }));
Us16.Size = 16;
Us16.Title = "Us";

export { Us16 as default };
